import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SyncLog } from '../models';

export const productsSyncActions = createActionGroup({
    source: 'Products Sync',
    events: {
        'Sync Items': emptyProps(),
        'Sync Items Success': emptyProps(),
        'Sync Items Error': props<{ code: number }>(),

        'Get Sync Status': emptyProps(),
        'Get Sync Status Success': props<{ payload: SyncLog }>(),
        'Get Sync Status Error': props<{ code: number }>(),

        'Get Sync Status Quiet': emptyProps(),
        'Get Sync Status Quiet Success': props<{ payload: SyncLog }>(),
        'Get Sync Status Quiet Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
